import React from 'react'
import _ from 'lodash'
import { useNavigate } from 'react-router-dom';

 

export default function EventsCard({ eventsDetails, handleEstimate }: any) {

   const navigate = useNavigate();
  const handleDetails = () => {
    navigate(`/events-details/${eventsDetails?.Id}`, { state: { eventsDetails } });
  };

   
      const image = require('../../assets/img/default community.jpg')
   
    return (
       <div   onClick={handleDetails} className="border border-gray-200 shadow rounded-lg overflow-hidden cursor-pointer w-72 mx-auto">
  <div className="flex flex-col items-center justify-center bg-gray-100 p-4">


    <div className="flex items-center justify-center w-full h-36 mb-4">
      {eventsDetails?.CoverImageUrl ? (
        <img
          src={eventsDetails?.CoverImageUrl}
          alt="Community details"
          className="w-36 h-36 object-cover"
        />
      ) : (
      <img
          src={image}
          alt="Community details"
          className="w-36 h-36 object-cover"
        />
      )}
    </div>

  
    <div className="text-start mb-4">
      <p className="text-sm text-gray-600">{eventsDetails?.Name}</p>
    
    </div>

   

  </div>
</div>



    );
}
